import React, {useState} from 'react';

import {Input, SmallLoader} from '@kit';

import {getApolloError} from '../../../../../components/utils';
import {MIN_QUERY_LENGTH, SearchItem, useItemSearch} from './use-item-search';

import css from '../sheet.module.css';

type Props = {
	placeholder?: string;
	/** какие предметы показывать: например, только магические */
	filter?(item: SearchItem): boolean;
	/** кнопка справа от найденного предмета */
	renderAction(item: SearchItem): React.ReactNode;
};

/** поле поиска по базе предметов и список найденного */
export const ItemSearchList: React.FC<Props> = ({placeholder = 'Найти предмет в базе', filter, renderAction}) => {
	const [query, setQuery] = useState('');
	const {results, loading, error} = useItemSearch(query, filter);
	const isQueryReady = query.trim().length >= MIN_QUERY_LENGTH;

	return (
		<section className={css.tabSection}>
			<Input
				autoFocus
				value={query}
				placeholder={placeholder}
				onChange={(value) => setQuery(String(value ?? ''))}
			/>
			{loading && <SmallLoader />}
			{error && <p className={css.muted}>{getApolloError(error).message}</p>}
			{isQueryReady && !loading && !results.length && <p className={css.muted}>Ничего не найдено.</p>}
			{results.length > 0 && (
				<ul className={css.rows}>
					{results.map((item) => (
						<li key={item.id} className={css.row}>
							<div className={css.rowMain}>
								<span className={css.rowTitle}>
									{item.title}
									<span className={css.muted}> {item.originalTitle}</span>
								</span>
								{renderAction(item)}
							</div>
						</li>
					))}
				</ul>
			)}
		</section>
	);
};
